import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import DeliveredProjectsBlock from '@/blocks/DeliveredProjectsBlock';
import TextImageAsideBlock from '@/blocks/TextImageAsideBlock';
import TextImageAsideDarkBlock from '@/blocks/TextImageAsideDarkBlock';
import CheckList from '@/components/CheckList';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { pages } from '@/content';
import { filterByCompany } from '@/hooks/project';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';

export default function ConstructionPage({ mainLayout, page }) {
  let { contentSection, metaData } = page.attributes;
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <BrandHeroBlock
        image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
        title={contentSection[0].heroTitle}
      />
      <BreadcrumbsBlock items={[pages.home, pages.construction]} />
      <TextImageAsideBlock
        image={MEDIA_URL.concat(contentSection[1].textImageAsideImage.data.attributes.url)}
        imageClassName="lg:aspect-square"
        imageDirection="right"
        subtitle={contentSection[1].textImageAsideSubtitle}
        title={contentSection[1].textImageAsideTitle}
      >
        <Markdown>{contentSection[1].textImageAsideText}</Markdown>
      </TextImageAsideBlock>
      <TextImageAsideDarkBlock
        image={MEDIA_URL.concat(contentSection[2].textImageADarkImage.data.attributes.url)}
        subtitle={contentSection[2].subtitle}
        title={contentSection[2].textImageADarkTitle}
      >
        <p className="text-xl">{contentSection[2].description}</p>
        <CheckList iconColor="text-white" items={contentSection[2].list} />
      </TextImageAsideDarkBlock>
      <DeliveredProjectsBlock projects={contentSection[3]} />
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'construction' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
